import { CrewMemberExpiredMilestoneStats, PlanningWeekStats, ProjectWeek } from '@bechtel/types';
import { MutableRefObject } from 'react';
import { PlanningTab } from '../types';

export enum SelectionSection {
  BACKLOG = 'backlog',
  PLANNED = 'planned',
}

export interface PlanningWeekCardProps {
  planWeekStats?: MutableRefObject<PlanningWeekStats[]>;
  onSelectWeekMilestones?: (weekNumber: number) => void;
  weekStatsRefetch?: MutableRefObject<(() => void) | null>;
}

export interface MilestoneIdentifier {
  dragIdentifier: string;
  canPlan: boolean;
}

export interface PlanningViewDetailProps {
  expiredMilestoneStats?: MutableRefObject<CrewMemberExpiredMilestoneStats>;
  isListCollapsed?: boolean;
  onTabChange: (index: number) => void;
  selectedProjectWeek?: ProjectWeek;
  selectedTab: PlanningTab;
}
